import { Box, Text, Title } from '@nimbus-ds/components';
import { PROJECT_SHIVA_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import useOnboardingTasks from '../OnboardingTasks/useOnboardingTasks';
import './HeaderPage.scss';

interface TitleWordBreakProps {
  children: React.ReactNode;
}

// We have incorporated this internal component with CSS to introduce
// the functionality of adding a line break to a long word,
// since Nimbus components do not support this property.
function TitleWordBreak({ children }: TitleWordBreakProps) {
  return <div className="stratus--title-word-break">{children}</div>;
}

function HeaderPage() {
  const t = useTranslationDashboard();
  const { isLoading, isSuccess, hasCompleted, isPos, isChat } =
    useOnboardingTasks();

  const [isShivaProject] = useHasTags(PROJECT_SHIVA_TAG);
  const getOnboardingStartedText = () => {
    const onboardingStarted = isShivaProject
      ? t('header.newOnboardingStartedShiva')
      : t('header.newOnboardingStarted');

    if (isChat) return t('header.chatOnboardingStarted');
    if (isPos) return t('header.posOnboardingStarted');
    return onboardingStarted;
  };

  return (
    <Box display="flex" flexDirection="column" gap="2">
      {isLoading && <Text.Skeleton width="340px" fontSize="highlight" />}
      {isSuccess && !hasCompleted && (
        <TitleWordBreak>
          <Title as="h6" fontWeight="regular">
            {getOnboardingStartedText()}
          </Title>
        </TitleWordBreak>
      )}
    </Box>
  );
}

export default HeaderPage;
